import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={1.8}
    className="tabler-icon tabler-icon-markdown opacity-90"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <path d="M7 15V9l2 2 2-2v6M14 13l2 2 2-2m-2 2V9" />
  </svg>
)
export default SvgComponent
